import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Declarant } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface UpdateDeclarantProps {
  declarant: Partial<Declarant>;
  declarantId: string;
}

export const useUpdateDeclarant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarant, declarantId }: UpdateDeclarantProps) => {
      await request({
        path: 'declarant',
        method: 'PATCH',
        authenticate: true,
        dataObject: { _id: declarantId, ...declarant },
      });
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declarant', variables.declarantId] });
      queryClient.invalidateQueries({ queryKey: ['declarants'] });
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
      toast.success('Account information saved successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error saving the account information!`);
    },
  });
};
